import React from "react";
import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.8, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const SectionHeading = ({ eyebrow, title, intro, align = "left" }) => (
    <div className={align === "center" ? "text-center" : ""}>
        {eyebrow && (
            <Reveal>
                <p className="text-xs uppercase tracking-[0.25em] font-sans font-bold text-[#718370]">{eyebrow}</p>
            </Reveal>
        )}
        <Reveal delay={0.08}>
            <h2 className="mt-3 font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-[#1A1D1A]">{title}</h2>
        </Reveal>
        {intro && (
            <Reveal delay={0.16}>
                <p className="mt-4 text-sm sm:text-base leading-relaxed text-[#6D736D]">{intro}</p>
            </Reveal>
        )}
    </div>
);
